export const outliersMessage = {
	DAP_ACIMA_ESTRATO: 'DAP acima do esperado considerando contexto de ESTRATO',
	DAP_ABAIXO_ESTRATO: 'DAP abaixo do esperado considerando contexto de ESTRATO',
	HT_ACIMA_ESTRATO: 'HT acima do esperado considerando contexto de ESTRATO',
	HT_ABAIXO_ESTRATO: 'HT abaixo do esperado considerando contexto de ESTRATO',
	DAP_HT_ACIMA_ESTRATO: 'DAP/HT acima do esperado considerando contexto de ESTRATO',
	DAP_HT_ABAIXO_ESTRATO: 'DAP/HT abaixo do esperado considerando contexto de ESTRATO',
	DAP_ACIMA_PLANTIO: 'DAP acima do esperado considerando contexto de PLANTIO:',
	DAP_ABAIXO_PLANTIO: 'DAP abaixo do esperado considerando contexto de PLANTIO:',
	HT_ACIMA_PLANTIO: 'HT acima do esperado considerando contexto de PLANTIO:',
	HT_ABAIXO_PLANTIO: 'HT abaixo do esperado considerando contexto de PLANTIO:',
	DAP_HT_ACIMA_PLANTIO: 'DAP/HT acima do esperado considerando contexto de PLANTIO:',
	DAP_HT_ABAIXO_PLANTIO: 'DAP/HT abaixo do esperado considerando contexto de PLANTIO:',
	DAP_ACIMA_PLANTIO_IDADE: 'DAP acima do esperado considerando a IDADE do PLANTIO',
	DAP_ABAIXO_PLANTIO_IDADE: 'DAP abaixo do esperado considerando a IDADE do PLANTIO',
	HT_ACIMA_PLANTIO_IDADE: 'HT acima do esperado considerando a IDADE do PLANTIO',
	HT_ABAIXO_PLANTIO_IDADE: 'HT abaixo do esperado considerando IDADE do PLANTIO',
	DAP_HT_ACIMA_PLANTIO_IDADE: 'DAP/HT acima do esperado considerando a IDADE do PLANTIO',
	DAP_HT_ABAIXO_PLANTIO_IDADE: 'DAP/HT abaixo do esperado considerando a IDADE do PLANTIO',
}
